import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { queryClient } from "@/lib/queryClient";
import { AuthProvider } from "@/hooks/use-auth";
import { ThemeProvider } from "@/hooks/use-theme";
import App from "./App";
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("Elemento #root não encontrado no index.html");

createRoot(container).render(
  <StrictMode>
    {/* A ordem importa: o cache precisa envolver tudo que busca dado, o tema
        precisa ser aplicado antes de qualquer coisa desenhar, e a sessão vem
        depois dos dois porque as telas dependem dela. */}
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <App />
          {/* O Toaster é irmão do roteador, e não filho de uma tela, para a
              confirmação de uma escrita sobreviver à navegação que vem logo
              depois dela. */}
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
